<template>
<main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
  <!--=====================================
     Page Header Details Section
  ======================================-->
  <section class="pt-32 max-md:pb-20 md:py-44 lg:pt-[200px] relative overflow-hidden">
    <!-- Gradient Background Wrapper -->
    <div id="hero-gradient-wrapper" class="absolute w-full h-full top-0 left-0 -z-10 blur-[35px] md:blur-[60px] sm:scale-[0.1] bg-blend-multiply md:scale-75">
      <img src="images/hero-gradient-background.png" alt="hero-gradient-background" id="hero-gradient" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-[45%]" />
    </div>

    <!-- Hero Content Container -->
    <div class="container reveal-me">
      <div class="text-center">
        <!-- Badge Component -->
        <div class="rv-badge mb-4 lg:mb-10">
          <span class="rv-badge-text">Services Details</span>
        </div>

        <!-- Hero Title -->
        <h1 class="mb-5 lg:mb-8">Design</h1>

        <!-- Hero Description -->
        <p class="max-md:max-w-[650px]">
          Create visually stunning and user-friendly experiences that leave a lasting impression. Our design expertise spans across:<br><br>
        </p>
      </div>
    </div>
  </section>

  <!--=====================================
     Services Details Section
  ======================================-->
  <section class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]">
    <div class="max-w-[1440px] mx-auto px-8 md:px-20">
      <div class="flex flex-col gap-8 lg:flex-row justify-start">
        <!-- Sticky Table of Contents -->
        <aside class="min-w-[275px] flex-1">
          <div class="sticky top-28">
            <div class="reveal-me">
              <h3 class="max-md:text-[40px] md:text-[32px]">Table of contents</h3>
              <ul class="mt-4 sm:mt-7 md:mt-10 [&>*:not(:last-child)]:mb-2 md:[&>*:not(:last-child)]:mb-5">
                <li>
                  <a href="#service-overview" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Service overview</a>
                </li>
                <li>
                  <a href="#our-service-includes" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Our service includes</a>
                </li>
                <li>
                  <a href="#why-choose" class="text-xl normal-case font-normal leading-7 tracking-normal dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">Why Choose Us</a>
                </li>
              </ul>
            </div>
          </div>
        </aside>

        <!-- Main Content -->
        <article class="project-details-body">
          <div class="reveal-me">
            <h3 id="service-overview">Service overview</h3>
            <p>
              At Neue Media, we specialize in creating visually compelling designs that blend creativity with functionality. We work closely with you to transform your vision into engaging visuals that resonate with your audience.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="our-service-includes">Our service includes</h3>
            <p>
              In-Depth Creative Consultation: We collaborate with you to understand your brand’s ethos and design requirements, ensuring every visual element aligns with your identity.<br><br>
              <strong>Brand Identity:</strong> Crafting logos, typography, and color palettes that create a cohesive brand image.<br><br>
              <strong>UI/UX Design:</strong> Designing intuitive interfaces and engaging layouts for web and mobile platforms.<br><br>
              <strong>Marketing Assets:</strong> Developing eye-catching visuals for social media, advertising, and presentations.
            </p>
          </div>
          <div class="reveal-me">
            <h3 id="why-choose">Why Choose Us</h3>
            <p>
              Expertise and Innovation: Our design team brings years of creative experience and a passion for innovation to every project.<br><br>
              Tailored Solutions: We craft bespoke designs that capture the essence of your brand.<br><br>
              Seamless Collaboration: Our transparent process ensures your vision is fully realized.<br><br>
              End-to-End Service: From concept to final production, we handle every aspect of the design process.<br><br>
              Speed and Efficiency: We deliver high-quality designs within your timeline without compromising on quality.<br><br>
              Results-Driven Approach: Our designs are created to engage, convert, and elevate your brand.
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!--=====================================
     CTA Section
  ======================================-->
  <section class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative">
    <div class="container">
      <!-- CTA Heading -->
      <h2 class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]">
        Got Questions?
        <span class="font-instrument sm:mt-10 italic block max-md:inline-block">
          We’ve Got Answers
        </span>
      </h2>

      <ul class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none">
        <!-- Primary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"></li>
        <!-- Secondary CTA Button -->
        <li class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto">
          <router-link to="/contact" class="rv-button rv-button-primary block md:inline-block">
            <div class="rv-button-top contact-btn-lg">
              <span>Let's Connect</span>
            </div>
            <div class="rv-button-bottom contact-btn-lg">
              <span>Let's Connect</span>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </section>

</main>

<!--=====================================
   Footer Section
======================================-->
<FooterComponent/>

</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue'
export default {
  name: 'DesignPage',
  components: {
    FooterComponent,
  }
}
</script>